import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getOfflineEncryptionDataQueryKey } from './offline.keys';
import { getOfflineEncryptionKey } from './offline.repository';
import { GetOfflineEncryptionKeyOutput, UseGetOfflineEncryptionKeyParams } from './offline.types';

export const useGetOfflineEncryptionKey = ({
  options,
  teamId,
}: UseGetOfflineEncryptionKeyParams = {}) =>
  useDataQuery<GetOfflineEncryptionKeyOutput>(
    {
      teamId,
      queryKey: getOfflineEncryptionDataQueryKey(),
      queryFn: async () => {
        const response = await getOfflineEncryptionKey();

        if (!response.ok || !response.data) {
          throw response.originalError;
        }

        return response.data;
      },
    },
    options,
  );
